module.exports = __webpack_public_path__ + "img/capability-img.9873f1da.png";